module.exports = "<a routerLink=\"/product/add\" class=\"btn btn-success btn-block\">\n  <i class=\"fa fa-plus\">New</i>\n</a>\n"